import { SVGProps } from 'react';

const Section = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 12c0 .796.421 1.559 1.172 2.121S10.939 15 12 15s2.078-.316 2.828-.879S16 12.796 16 12c0-4-8-3-8-7 0-.796.421-1.559 1.172-2.121S10.939 2 12 2s2.078.316 2.828.879S16 4.204 16 5m0 7c0-.796-.421-1.559-1.172-2.121S13.061 9 12 9s-2.078.316-2.828.879S8 11.204 8 12m0 0c0 4 8 3 8 7 0 .796-.421 1.559-1.172 2.121S13.061 22 12 22s-2.078-.316-2.828-.879S8 19.796 8 19"
    />
  </svg>
);
export default Section;
